import React from "react";

import { ReactComponent as ClockIcon } from '../../assets/img/ico/calendar.svg';
import { ReactComponent as LocationIcon } from '../../assets/img/ico/map-pin.svg';
import { ReactComponent as EuroIcon } from '../../assets/img/ico/euro-icon.svg';
import { Link } from "react-router-dom";

const AgencyOfferCard = ({ offer }) => (
    <div className="aoc-offer-card">
        <div className="aoc-offer-header">
            <h3 className="aoc-offer-title">{offer.title}</h3>
        </div>
        <div className="aoc-offer-body">
            <span className="aoc-offer-date-relative">{offer.relativeDate}</span>
            <div className="aoc-offer-info-item">
                <ClockIcon className="aoc-icon small" />
                <div className="aoc-info-text">
                    <span>{offer.dateRange}</span>
                    <span className="aoc-info-value">{offer.daysWorked}</span>
                </div>
            </div>
            <div className="aoc-offer-info-item">
                <LocationIcon className="aoc-icon small" />
                 <div className="aoc-info-text">
                    <span className="aoc-info-label">Lieu</span>
                    <span className="aoc-info-value">{offer.location}</span>
                 </div>
            </div>
            <div className="aoc-offer-info-item">
                <EuroIcon className="aoc-icon small" />
                 <div className="aoc-info-text">
                    <span className="aoc-info-label">Salaire</span>
                    <span className="aoc-info-value">{offer.salary}</span>
                </div>
            </div>
        </div>
        <div className="aoc-offer-footer">
            <Link to={"/mission-detail"} className="aoc-offer-link">Voir l'offre</Link>
        </div>
    </div>
);

export default AgencyOfferCard;